/**
 * Animates slide up.
 *
 * Replacement for jQuery slideUp animation.
 *
 * @param element           The element to slide up.
 * @param [duration=400]    The duration of the animation in milliseconds.
 * @param [display="block"] The elements initial display property.
 */
const slideUp = (element: HTMLElement, duration = 400, display = 'block'): void => {
	// Make the element visible and reset its height
	element.style.display = display;
	const height = element.offsetHeight;

	// Set the element's height to its current pixel height, overflow hidden, and transition properties
	element.style.height = height + 'px';
	element.style.overflow = 'hidden';
	element.style.transition = `height ${duration}ms ease-out`;

	// Trigger reflow to apply the height style before changing it
	requestAnimationFrame(() => {
		element.style.height = '0';
	});

	// Listen for transition end to reset styles and hide the element
	element.addEventListener('transitionend', function handler() {
		element.style.display = 'none';
		element.style.removeProperty('height');
		element.style.removeProperty('overflow');
		element.style.removeProperty('transition');
		element.removeEventListener('transitionend', handler);
		window.dispatchEvent(new Event('slideAnimationEnd'));
	});
};

/**
 * Animate slide down
 *
 * Replacement for jQuery slideDown animation.
 *
 * @param element           The element to slide down.
 * @param [duration=400]    The duration of the animation in milliseconds.
 * @param [display="block"] The elements initial display property.
 */
const slideDown = (element: HTMLElement, duration = 400, display = 'block'): void => {
	// Make the element visible and reset its height
	element.style.display = display;
	element.style.height = 'auto';

	// Get the full height of the element's content
	const height = element.offsetHeight;

	// Set the height to 0 initially and then animate to the full height
	element.style.height = '0';
	element.style.overflow = 'hidden';
	element.style.transition = `height ${duration}ms ease-out`;

	// Trigger reflow to apply the initial height style
	requestAnimationFrame(() => {
		element.style.height = height + 'px';
	});

	// Listen for transition end to reset styles
	element.addEventListener('transitionend', function handler() {
		element.style.display = display;
		element.style.removeProperty('height');
		element.style.removeProperty('overflow');
		element.style.removeProperty('transition');
		element.removeEventListener('transitionend', handler);
		window.dispatchEvent(new Event('slideAnimationEnd'));
	});
};

const getOffsetTop = (element: HTMLElement | null) => {
	let offsetTop = 0;
	while (element) {
		offsetTop += element.offsetTop;
		element = element.offsetParent as HTMLElement;
	}
	return offsetTop;
};

export { slideUp, slideDown, getOffsetTop };
